export const types = <const>{
	mutations: {
		NOVE_VOZY_TYP_KOD_SELECT_MAPPER: 'NOVE_VOZY_TYP_KOD_SELECT_MAPPER',
		NOVE_VOZY_MODEL_SELECT_MAPPER: 'NOVE_VOZY_MODEL_SELECT_MAPPER',
		NOVE_VOZY_PVN_ID_SELECT_MAPPER: 'NOVE_VOZY_PVN_ID_SELECT_MAPPER',
		NOVE_VOZY_BARVA_SELECT_MAPPER: 'NOVE_VOZY_BARVA_SELECT_MAPPER',
		NOVE_VOZY_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'NOVE_VOZY_NAKLADOVE_STREDISKO_SELECT_MAPPER',
		NOVE_VOZY_TYP_KOD_LIST_SELECT_MAPPER: 'NOVE_VOZY_TYP_KOD_LIST_SELECT_MAPPER',
	},
};
